<h3 class="display-10">{{ 'store.invitation.describeTitle' | translate }}</h3>

<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <div class="form-group mb-4">
    <header class="header-input-filed ">{{ 'common.description' | translate }}</header>
    <textarea id="inputEmail"
              style="height: 139px"
              formControlName="description"
              [ngClass]="{ 'is-invalid': submitted && f.description.errors }"
              [placeholder]="'store.invitation.descriptionPlaceholder' | translate"
              required="" autofocus=""
              class="form-control form-control-with-validation">
    </textarea>
    <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
      <div *ngIf="f.description.errors.required">{{ 'store.invitation.descriptionRequired' | translate }}</div>
    </div>
  </div>
  <button type="submit" class="btn btn-primary">{{ 'common.next' | translate }}</button>
</form>
